import { useState, useContext, useEffect } from "react"
import Button from 'react-bootstrap/Button';
import { AuthContext } from "../../context/AuthContext";
import InputListing from "../InputListing";
import ModalWrapper from "../ModalWrapper";
import { LoginModalContext } from "../../context/LoginModalContext";
import { useNavigate, useLocation, NavLink } from 'react-router-dom';

const BottomBar = ({ bottomBarNotif }) => {
    const { currentUser, logout } = useContext(AuthContext)
    const { setLoginModalOpen} = useContext(LoginModalContext)
    const navigate = useNavigate();
    const location = useLocation();

    const [inputListingOpen, setInputListingOpen] = useState(false)

    useEffect(() => {
        if (currentUser) {
            const element = document.getElementById("bottom-bar-inbox")
            if (bottomBarNotif > 0) {
                element.style.setProperty("--unread-chats", `"${bottomBarNotif}"`)
                element.classList.add("unread")
                document.title = `(${bottomBarNotif}) Phreesh - your neighborhood treasure trove`
            } else {
                element.classList.remove("unread")
                document.title = `Phreesh - your neighborhood treasure trove`
            }
        }
    }, [bottomBarNotif]);

    const navItems = [
        { label: 'Home', path: '/', icon: "home", id: 'home' },
        { label: 'My Listings', path: '/mylistings', icon: "sell", id: 'myListings' },
        { label: 'Saved', path: '/myoffers', icon: "bookmarks", id: 'saved' },
        { label: 'Inbox', path: '/inbox', icon: "mail", id: 'bottom-bar-inbox'},
    ];

    const handleLogout = async () => {
        try {
            await logout()
            navigate("/")
            window.location.reload()
        } catch {
            console.log("error logging out")
        }
    }

    if (!currentUser) {
        return (
            <nav className="bottom-bar-container">
                <div className="bottom-bar-div">
                    <NavLink
                        onClick={() => setLoginModalOpen(true)}
                        className="bottom-bar-button"
                    >
                        <i className="material-icons"> login </i>
                        <span className="bottom-bar-text">
                            Login
                        </span>
                    </NavLink>
                </div>
            </nav>
        )
    }

    return (
        <nav className="bottom-bar-container">
            {
                    currentUser ?
                    <ModalWrapper
                        show={inputListingOpen}
                        onHide={() => setInputListingOpen(false)}
                        heading="Create Listing"
                    >
                        <InputListing 
                            disabled={!currentUser.emailVerified}
                        />
                    </ModalWrapper>:
                    <></>
                }
        <div className="bottom-bar-div ">
            {navItems.map((item) => {
                const isActive = location.pathname === item.path;

                return (
                    <NavLink
                        key={item.label}
                        to={{pathname: item.path}}
                        onClick={(e) => {
                            if (item.isAction) {
                                e.preventDefault()
                                item.onClick()
                            }
                        }}
                        className={({isActive}) => isActive ? "bottom-bar-button bottom-bar-active" : "bottom-bar-button"}
                    >
                    {/* <div id={item.id}> */}
                        <i className="material-icons" id={item.id}> {item.icon} 
                            <span className="inbox-notification-container" />
                        </i>
                    {/* </div> */}
                    <span className={`text-[10px] font-medium ${isActive ? 'text-blue-600' : 'text-gray-500'}`}>
                        {item.label}
                    </span>
                    </NavLink>
                );
            })}
            <NavLink
                onClick={() => setInputListingOpen(true)}
                className="bottom-bar-button"
            >
                <i className="material-icons"> add_box </i>
                <span className="bottom-bar-text">
                    New
                </span>
            </NavLink>

            <li className="dropdown bottom-bar-button">
                {currentUser.avatarUrl ?
                <img src={currentUser.avatarUrl} className="avatar avatar-nav nav-item dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false"/>:
                <i className="material-icons avatar avatar-nav dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">account_circle</i>}
                <span className="bottom-bar-text">
                    Me
                </span>
                <ul className="dropdown-menu" id="dropdown-menu">
                    <li><NavLink className="dropdown-item" to={{pathname:`/user/${currentUser.uid}`}}>Profile</NavLink></li>
                    <li><NavLink className="dropdown-item" to={{pathname:"/archive"}}>Archive</NavLink></li>
                    <li onClick={handleLogout}><NavLink className="dropdown-item" to={{pathname:""}}>Logout</NavLink></li>
                </ul>
            </li>
        </div>
        </nav>
  )
}

export default BottomBar
